import { apiSlice } from '../apiSlice';
import { API_TAGS } from '../../constants/api';
import { MESSAGES } from './ticketsMessages';

export const ticketsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchTickets: builder.query({
      query: ({ orgId, tenantId, urlParams = {} }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/tickets`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_TICKETS.ERROR,
          // currently bots with no enabled integrations or integrations with configuration errors return 400
          errorCodesToIgnore: [400]
        }
      }),
      providesTags: (result, error, args) => {
        return [{ type: API_TAGS.TICKETS, id: 'LIST' }];
      }
    }),

    fetchTicket: builder.query({
      query: ({ orgId, tenantId, ticketId, urlParams = { showMessage: true } }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/tickets/${ticketId}`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_TICKET.ERROR
        }
      })
    })
  })
});

export const {
  useFetchTicketsQuery,
  useFetchTicketQuery
} = ticketsSlice;
